export const COLORS = {
  //Current color pallette:
  // https://coolors.co/03045e-0077b6-00b4d8-90e0ef-caf0f8

  primary: "#03045E",
  secondary: "#0077B6",
  third: "#00B4D8",
  fourth: "#90E0EF",
  fifth: "#CAF0F8",
  lightGrey: '#f0f4ef',
 

};

export const FONTS = {

  
}